import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import {
  NavLink,
  useNavigate,
  useParams,
} from "react-router-dom";

import Base from "../core/static/Base";
import {
  resetPassword,
  verifyResetPasswordToken,
} from "./helper";

const ResetPassword = () => {
  const { resetToken } = useParams();
  const navigate = useNavigate();

  const [values, setValues] = useState({
    password: "",
    retypepassword: "",
  });

  const [status, setStatus] = useState({
    verifying: true,
    tokenValid: false,
    loading: false,
    success: "",
    error: "",
  });

  const { password, retypepassword } = values;

  useEffect(() => {
    let componentMounted = true;

    const verifyToken = async () => {
      if (!resetToken) {
        if (componentMounted) {
          setStatus({
            verifying: false,
            tokenValid: false,
            loading: false,
            success: "",
            error: "Password reset token is unavailable.",
          });
        }

        return;
      }

      const data = await verifyResetPasswordToken(resetToken);

      if (!componentMounted) {
        return;
      }

      if (data.error) {
        setStatus({
          verifying: false,
          tokenValid: false,
          loading: false,
          success: "",
          error: data.error,
        });

        return;
      }

      setStatus({
        verifying: false,
        tokenValid: true,
        loading: false,
        success: "",
        error: "",
      });
    };

    verifyToken();

    return () => {
      componentMounted = false;
    };
  }, [resetToken]);

  const handleChange = (name) => (event) => {
    setValues({
      ...values,
      [name]: event.target.value,
    });

    setStatus((currentStatus) => ({
      ...currentStatus,
      success: "",
      error: "",
    }));
  };

  const onSubmit = async (event) => {
    event.preventDefault();

    if (password.length < 6) {
      setStatus((currentStatus) => ({
        ...currentStatus,
        loading: false,
        success: "",
        error: "Password must contain at least 6 characters.",
      }));

      return;
    }

    if (password !== retypepassword) {
      setStatus((currentStatus) => ({
        ...currentStatus,
        loading: false,
        success: "",
        error: "Password and Retype Password do not match.",
      }));

      return;
    }

    setStatus((currentStatus) => ({
      ...currentStatus,
      loading: true,
      success: "",
      error: "",
    }));

    const data = await resetPassword(
      resetToken,
      password,
      retypepassword
    );

    if (data.error) {
      setStatus((currentStatus) => ({
        ...currentStatus,
        loading: false,
        success: "",
        error: data.error,
      }));

      return;
    }

    setValues({
      password: "",
      retypepassword: "",
    });

    setStatus({
      verifying: false,
      tokenValid: false,
      loading: false,
      success:
        data.message ||
        "Your password has been reset successfully.",
      error: "",
    });

    window.setTimeout(() => {
      navigate("/login");
    }, 3000);
  };

  const resetPasswordForm = () => {
    if (status.verifying) {
      return (
        <div className="alert alert-info text-center">
          Verifying password reset link...
        </div>
      );
    }

    if (!status.tokenValid) {
      return (
        <div>
          {status.success && (
            <div
              className="alert alert-success text-center"
              role="alert"
            >
              {status.success}
            </div>
          )}

          {status.error && (
            <div
              className="alert alert-danger text-center"
              role="alert"
            >
              {status.error}
            </div>
          )}

          <div className="text-center mt-3">
            <NavLink to="/forgotPassword">
              Request a new password reset link
            </NavLink>
          </div>

          <div className="text-center mt-2">
            <NavLink to="/login">Back to Login</NavLink>
          </div>
        </div>
      );
    }

    return (
      <form
        id="contact-form"
        onSubmit={onSubmit}
      >
        <div className="row">
          <div className="col-lg-12">
            <div className="section-heading">
              <h2>
                <em>Reset Password</em>
              </h2>

              <p>
                Enter and confirm your new password.
              </p>

              {status.error && (
                <div
                  className="alert alert-danger"
                  role="alert"
                >
                  {status.error}
                </div>
              )}
            </div>
          </div>

          <div className="col-lg-12">
            <fieldset>
              <input
                type="password"
                name="password"
                id="reset-password"
                placeholder="New Password"
                value={password}
                onChange={handleChange("password")}
                autoComplete="new-password"
                minLength="6"
                required
              />
            </fieldset>
          </div>

          <div className="col-lg-12">
            <fieldset>
              <input
                type="password"
                name="retypepassword"
                id="reset-retype-password"
                placeholder="Retype New Password"
                value={retypepassword}
                onChange={handleChange("retypepassword")}
                autoComplete="new-password"
                minLength="6"
                required
              />
            </fieldset>
          </div>

          <div className="col-lg-12">
            <fieldset>
              <button
                type="submit"
                id="reset-password-submit"
                className="orange-button"
                disabled={status.loading}
              >
                {status.loading
                  ? "Resetting..."
                  : "Reset Password"}
              </button>
            </fieldset>
          </div>

          <div className="col-lg-12 text-center mt-3">
            <NavLink to="/login">
              Back to Login
            </NavLink>
          </div>
        </div>
      </form>
    );
  };

  return (
    <div>
      <Helmet>
        <title>Scope Ebook - Reset Password</title>
      </Helmet>

      <Base>
        <div className="row">
          <div className="contact-us section" id="contact">
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <div className="contact-us-content">
                    <div className="row">
                      <div
                        className="col-lg-4"
                        style={{ margin: "auto" }}
                      >
                        <img
                          src="/images/scopeEbook.png"
                          alt="Scope Ebook"
                        />
                      </div>

                      <div className="col-lg-8">
                        {resetPasswordForm()}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Base>
    </div>
  );
};

export default ResetPassword;